<template>
    <div class="container-fluid">
    <div class="herosection">
        <NavbarSection />
        <div class="overlay-img"></div>
        <div class="heroWriteup">
            <h2>Photo Gallery</h2>
            <p>Explore moments from our tournaments, events, and everyday club life captured in photos and videos that showcase the spirit of LLTC.</p>
        </div>
    </div>
    <br>
    <br>
    <div class="media-image">
        <div class="card col-12 col-sm-6 col-md-4 col-lg-3">
            <div class="blog-img">
                <img :src="base_url + dataList.banner_image" alt="">
            </div>
            <div class="blog-content p-4">
                <h4>{{ dataList.title}}</h4>
                <div style="text-align: justify;" v-html="dataList.description"></div>
            </div>
        </div>
        <div class="d-flex flex-column p-4 archives-setting">
                <p><strong>Archives</strong></p>
                <ul class="list-group">
                    <li 
                        v-for="(item, index) in archives"
                        :key="index"
                        class="list-group-item archive-item"
                        @click="goToArchive(item)"
                        style="cursor: pointer;"
                    >
                        {{ item.archive_date }}
                    </li>
                </ul>
        </div>
    </div>
    


    <FooterSection />
</div>
</template>

<script setup>
/* eslint-disable */
import FooterSection from '@/components/FooterSection.vue';
import NavbarSection from '@/components/NavbarSection.vue';
import MediaPage from '@/components/MediaPage.vue';
import { ref, nextTick, onMounted } from "vue"
import axios from 'axios';
//import router from "@/router";
import { useRoute } from 'vue-router'

const route = useRoute()

const archives = ref([]);
const dataList = ref([]);
const dataId = ref('')
let base_url = process.env.VUE_APP_BASE_LIVE_URL

onMounted( async () => {
  dataId.value = route.params.title
  console.log(dataId.value)
  await listRecords();
  await listArchives();
  await nextTick();
  window.scrollTo({ top: 0 });
});


// Fetch records
const listRecords = async () => {
  try {
    const response = await axios.get(`/photo_gallery_detail.php?id=${dataId.value}`);
    dataList.value = response.data.data
  } catch (error) {
    console.error(error.message);
  }
};

const listArchives = async () => {
  try {
    const response = await axios.get(`/photo_gallery_archives.php`);
    archives.value = response.data.data;  // Expect: [{archive_date: "September 2024"}]
  } catch (error) {
    console.error(error.message);
  }
};

const goToArchive = (item) => {
  // Redirect to archive page
  window.location.href = `/media-gallery/archive/${item.archive_date}`;
};


</script>

<style lang="scss" scoped>
.media-image{
   display: flex;
   flex-direction: row;
}

@media (max-width: 768px) {
    .media-image{
        display: flex;
        flex-direction: column !important;
    }
}
.archives-setting{
    font-size: 12px !important;
    font-family: Comic Sans MS !important;
}
.herosection {
    border-radius: 20px;
    background-image: url('../assets/images/media_gallery/media.png');
    background-size: cover;
    height: 764px;
    padding: 10px;
    position: relative;
    width: 100%;
    overflow: hidden;
    padding:1.5rem 4rem 0 4rem;
}

/* Dark overlay */
.herosection::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    /* Adjust opacity for darkness */
    z-index: 1;
    /* sits above images but below content */
}

.overlay-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 0;
    background: linear-gradient(180deg, rgba(9, 73, 35, 0) 0%, #01170A 100%);
}

.heroWriteup,
NavbarSection {
    position: relative;
    z-index: 2;
    /* ensures text and navbar appear above overlay */
}


.heroWriteup {
    position: absolute;
    max-width: 650px;
    text-align: left;
    bottom: 20%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    gap: 10px;
    justify-content: center;
    align-items: center;
    color: white;

    h2 {
        font-size: 45px;
        font-weight: 700;
        font-family: "Open Runde", sans-serif;
        text-align: center;
    }

    p {
        font-size: 16px;
        font-weight: 500;
        font-family: "Open Runde", sans-serif;
        text-align: center;

    }

    .register {
        background-color: #ed4e24;
        border: 2px solid #7c7777;
        color: white;
        border-radius: 30px;
        font-family: "Open Runde", sans-serif;
        font-size: 16px;
        padding: 15px 25px;
        cursor: pointer;
        transition: 0.3s ease;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 10px;
    }
}

.card {
    display: flex !important;
    flex-direction: row !important;
    width: 80%;
    height: auto;
    //margin: 2rem auto;
    opacity: 1;
    border-radius: 24px;
    padding: 20px;
    border: 1px solid #E7E7E7
}
.blog-img img{
        max-width: 450px;
        height: 320px;
        padding: 0;
        opacity: 1;
       
}
.blog-content{
    width: 100%;
    padding-top: 22px;
    padding-bottom: 22px;
    opacity: 1;
}
.accordion-list {
    width: 100%;
    padding-top: 60px;
    padding-right: 80px;
    padding-bottom: 0px;
    padding-left: 80px;
    opacity: 1;
    border-radius: 40px;
    border-width: 1px;
}

.policy-title{
    font-size: 20px;
    line-height: 100%;
    text-align: left;
    margin-bottom: 50px;
}
.question-content{
    text-align: left;
}
.accordion-item {
    border-bottom: 1px solid #00000040;
    padding: 12px 0;
}

.accordion-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    background: none;
    border: none;
    padding: 0;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    text-align: left;
}

.accordion-title {
    flex: 1;
    font-weight: 500;
    font-family: "Open Runde", sans-serif;
    color: #000000;
    font-size: 18px;
}

.accordion-icon {
    width: 30px;
    height: 30px;
    transition: transform 0.2s ease;
}

.accordion-icon.rotated {
    transform: rotate(180deg);
}

.accordion-content {
    margin-top: 8px;
    font-size: 14px;
    line-height: 1.6;
    color: #333;
    text-align: left;
}

/* Smooth open/close transition */
.accordion-enter-active,
.accordion-leave-active {
    transition: max-height 0.25s ease, opacity 0.2s ease;
}

.accordion-enter-from,
.accordion-leave-to {
    max-height: 0;
    opacity: 0;
}

.accordion-enter-to,
.accordion-leave-from {
    max-height: 200px;
    opacity: 1;
}

@media (max-width: 768px) {
    .herosection {
        border-radius: 20px;
        background-image: url('../assets/images/HeroBg.png');
        background-size: cover;
        height: 624px;
        padding: 10px;
        position: relative;
        width: 100%;

    }

    .card {
        width: 100%;
        margin: 1rem auto;
        height: auto;
        display: flex;
        flex-direction: column !important;
        justify-content: center;
        align-items: start;
        background-color: #ffffff;
        border-radius: 40px;
        border: 1px solid #00000033;
        padding: 10px 0px;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
    img{
            width: 100%;
            height: 320px;
            padding: 20px !important;
            opacity: 1;
            border-radius: 10px !important;
    }

    .overlay-img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        /* make it cover */
        height: 100%;
        object-fit: cover;
        /* prevent distortion */
        opacity: 0.6;
        /* control transparency */
    }



    .heroWriteup {
        position: absolute;
        width: 100%;
        text-align: left;
        top: 60%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        flex-direction: column;
        gap: 10px;
        justify-content: center;
        align-items: center;
        color: white;

        h2 {
            font-size: 28px;
            font-weight: 700;
            font-family: "Open Runde", sans-serif;
            text-align: center;
        }

        p {
            font-size: 14px;
            font-weight: 500;
            font-family: "Open Runde", sans-serif;
            text-align: center;

        }

        .register {
            background-color: #ed4e24;
            border: 2px solid #7c7777;
            color: white;
            border-radius: 30px;
            font-family: "Open Runde", sans-serif;
            font-size: 16px;
            padding: 15px 25px;
            cursor: pointer;
            transition: 0.3s ease;
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 10px;
        }
    }
}


</style>
